"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANEL_NAME_LABEL_EN = exports.PANEL_NAME_DESCRIPTION_EN = exports.PANEL_NAME_DESCRIPTION_FR = exports.PANEL_NAME_LABEL_FR = void 0;
var PANEL_NAME_LABEL_FR;
(function (PANEL_NAME_LABEL_FR) {
    PANEL_NAME_LABEL_FR["BERLINE"] = "Berline green";
    PANEL_NAME_LABEL_FR["BUSINESS"] = "Berline affaires";
    PANEL_NAME_LABEL_FR["VAN"] = "Van";
    PANEL_NAME_LABEL_FR["COVTC"] = "Pool";
    PANEL_NAME_LABEL_FR["MOTO"] = "Moto taxi";
    PANEL_NAME_LABEL_FR["GREEN"] = "Green";
    PANEL_NAME_LABEL_FR["VAO"] = "Vao";
    PANEL_NAME_LABEL_FR["TAXI"] = "Taxi";
    PANEL_NAME_LABEL_FR["TAXI_VAN"] = "Van taxi";
    PANEL_NAME_LABEL_FR["TAXI_CONV"] = "Taxi conventionn\u00E9";
    PANEL_NAME_LABEL_FR["ACCESS"] = "Access";
    PANEL_NAME_LABEL_FR["VAN_ACCESS"] = "Van Access";
    PANEL_NAME_LABEL_FR["AMBULANCE"] = "Ambulance";
    PANEL_NAME_LABEL_FR["UNKNOWN"] = "Inconnu";
})(PANEL_NAME_LABEL_FR = exports.PANEL_NAME_LABEL_FR || (exports.PANEL_NAME_LABEL_FR = {}));
var PANEL_NAME_DESCRIPTION_FR;
(function (PANEL_NAME_DESCRIPTION_FR) {
    PANEL_NAME_DESCRIPTION_FR["BERLINE"] = "70% v\u00E9hicules bas carbone";
    PANEL_NAME_DESCRIPTION_FR["BUSINESS"] = "Service haut de gamme";
    PANEL_NAME_DESCRIPTION_FR["VAN"] = "Pour les groupes";
    PANEL_NAME_DESCRIPTION_FR["COVTC"] = "Pool";
    PANEL_NAME_DESCRIPTION_FR["MOTO"] = "Confort & anti-bouchon";
    PANEL_NAME_DESCRIPTION_FR["GREEN"] = "Hybride ou \u00E9lectrique";
    PANEL_NAME_DESCRIPTION_FR["VAO"] = "100% \u00E9lectrique type Tesla";
    PANEL_NAME_DESCRIPTION_FR["TAXI"] = "Taxi berline";
    PANEL_NAME_DESCRIPTION_FR["TAXI_VAN"] = "Taxi van";
    PANEL_NAME_DESCRIPTION_FR["TAXI_CONV"] = "Taxi avec convention";
    PANEL_NAME_DESCRIPTION_FR["ACCESS"] = "Adapt\u00E9 au fauteuil";
    PANEL_NAME_DESCRIPTION_FR["VAN_ACCESS"] = "1 \u00E0 5 fauteuils roulants";
    PANEL_NAME_DESCRIPTION_FR["AMBULANCE"] = "Ambulance";
    PANEL_NAME_DESCRIPTION_FR["UNKNOWN"] = "";
})(PANEL_NAME_DESCRIPTION_FR = exports.PANEL_NAME_DESCRIPTION_FR || (exports.PANEL_NAME_DESCRIPTION_FR = {}));
var PANEL_NAME_DESCRIPTION_EN;
(function (PANEL_NAME_DESCRIPTION_EN) {
    PANEL_NAME_DESCRIPTION_EN["BERLINE"] = "70% low-carbon vehicles";
    PANEL_NAME_DESCRIPTION_EN["BUSINESS"] = "Luxury cars and services";
    PANEL_NAME_DESCRIPTION_EN["VAN"] = "Spacious cars for groups";
    PANEL_NAME_DESCRIPTION_EN["COVTC"] = "Pool";
    PANEL_NAME_DESCRIPTION_EN["MOTO"] = "Motorcycle taxi";
    PANEL_NAME_DESCRIPTION_EN["VAO"] = "100% electric like Tesla";
    PANEL_NAME_DESCRIPTION_EN["GREEN"] = "Electric & hybrid vehicle";
    PANEL_NAME_DESCRIPTION_EN["TAXI"] = "Taxi sedan";
    PANEL_NAME_DESCRIPTION_EN["TAXI_VAN"] = "Taxi van";
    PANEL_NAME_DESCRIPTION_EN["TAXI_CONV"] = "Agreed taxi";
    PANEL_NAME_DESCRIPTION_EN["ACCESS"] = "Wheelchair accessible";
    PANEL_NAME_DESCRIPTION_EN["VAN_ACCESS"] = "1 to 5 wheelchairs";
    PANEL_NAME_DESCRIPTION_EN["AMBULANCE"] = "Ambulance";
    PANEL_NAME_DESCRIPTION_EN["UNKNOWN"] = "";
})(PANEL_NAME_DESCRIPTION_EN = exports.PANEL_NAME_DESCRIPTION_EN || (exports.PANEL_NAME_DESCRIPTION_EN = {}));
var PANEL_NAME_LABEL_EN;
(function (PANEL_NAME_LABEL_EN) {
    PANEL_NAME_LABEL_EN["BERLINE"] = "Green sedan";
    PANEL_NAME_LABEL_EN["BUSINESS"] = "Business class";
    PANEL_NAME_LABEL_EN["VAN"] = "Van";
    PANEL_NAME_LABEL_EN["COVTC"] = "Pool";
    PANEL_NAME_LABEL_EN["VAO"] = "Vao";
    PANEL_NAME_LABEL_EN["MOTO"] = "Moto taxi";
    PANEL_NAME_LABEL_EN["GREEN"] = "Green";
    PANEL_NAME_LABEL_EN["TAXI"] = "Taxi";
    PANEL_NAME_LABEL_EN["TAXI_VAN"] = "Van taxi";
    PANEL_NAME_LABEL_EN["TAXI_CONV"] = "Agreed taxi";
    PANEL_NAME_LABEL_EN["ACCESS"] = "Access";
    PANEL_NAME_LABEL_EN["VAN_ACCESS"] = "Van Access";
    PANEL_NAME_LABEL_EN["AMBULANCE"] = "Ambulance";
    PANEL_NAME_LABEL_EN["UNKNOWN"] = "Unknown";
})(PANEL_NAME_LABEL_EN = exports.PANEL_NAME_LABEL_EN || (exports.PANEL_NAME_LABEL_EN = {}));
